import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/global/Sidebar";
import Toolbar from "../components/global/Toolbar";
import "../styles/pages/SharedLayout.scss";

const SharedLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  useEffect(() => {
    const rootDiv = document.getElementById("root");
    if (rootDiv) {
      rootDiv.classList.toggle("sidebar-collapsed", isSidebarCollapsed);
      rootDiv.classList.toggle("sidebar-expanded", !isSidebarCollapsed);
    }
  }, [isSidebarCollapsed]);

  return (
    <>
      <Toolbar />
      <Sidebar
        isSidebarCollapsed={isSidebarCollapsed}
        setIsSidebarCollapsed={setIsSidebarCollapsed}
      />
      <div className="main-content">
        <Outlet />
      </div>
    </>
  );
};

export default SharedLayout;
